import type { CSSProperties } from "react";
import { mergeStyles } from "@fluentui/react";

export const subscriptionPageStyle: CSSProperties = {
    paddingRight: 40,
    height: "calc(100vh - 50px)",
    overflow: "hidden",
};

export const subscriptionContentStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
};

export const subscriptionTableContainerStyles = {
    flexGrow: 1,
    minHeight: 0,
    position: "relative" as const,
};

export const subscriptionTableContainerStyle = mergeStyles(subscriptionTableContainerStyles);
